import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_K9: TStep[] = [
  {
    pageId: PageId.DOG_AGE_K9,
  },
  {
    pageId: PageId.DOG_SEX_K9,
  },
  {
    pageId: PageId.DOG_BREED_K9,
  },
  {
    pageId: PageId.DOG_BREED_ID_K9,
  },
  {
    pageId: PageId.URGE_K9,
  },
  {
    pageId: PageId.CHALLENGES_K9,
  },
  {
    pageId: PageId.URGE_1_K9,
  },
  {
    pageId: PageId.LEASH_PULLING_K9,
  },
  {
    pageId: PageId.URGE_LEASH_K9,
  },
  {
    pageId: PageId.DURING_WALK_K9,
  },
  {
    pageId: PageId.URGE_NOT_ALONE_K9,
  },
  {
    pageId: PageId.AGRESSIVE_BEHAVIOR_K9,
  },
  {
    pageId: PageId.TRIGGERS_K9,
  },
  {
    pageId: PageId.URGE_2_K9,
  },
  {
    pageId: PageId.BEHAVIOR_ISSUES_K9,
  },
  {
    pageId: PageId.DOG_ACT_K9,
  },
  {
    pageId: PageId.DOG_OFF_AT_HOME_K9,
  },
  {
    pageId: PageId.REWARDS_K9,
  },
  {
    pageId: PageId.IGNORE_COMMANDS_K9,
  },
  {
    pageId: PageId.COMMANDS_61_K9,
  },
  {
    pageId: PageId.COMMANDS_62_K9,
  },
  {
    pageId: PageId.COMMANDS_63_K9,
  },
  {
    pageId: PageId.URGE_3_K9,
  },
  {
    pageId: PageId.PREPARE_SCREEN_K9,
  },
  {
    pageId: PageId.DOG_PROFILE_K9,
  },
  {
    pageId: PageId.URGE_REVIEWED_K9,
  },
  {
    pageId: PageId.SOCIAL_SCREEN_K9,
  },
  {
    pageId: PageId.PREPARE_FLOW_K9,
  },
  {
    pageId: PageId.EMAIL_K9,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_K9,
  },
  {
    pageId: PageId.DISCIPLINE_SCREEN_K9,
  },
  {
    pageId: PageId.SCRATCH_SCREEN_K9,
  },
  {
    pageId: PageId.WELCOME_TO_WOOFZ_K9,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_K9,
  },
  {
    pageId: PageId.CHAT_UPSELL_K9,
  },
  {
    pageId: PageId.UPSELL_K9,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_K9,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_K9,
  },
  {
    pageId: PageId.DOWNLOAD_K9,
  },
  {
    pageId: PageId.ACCOUNT_K9,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_K9.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_K9.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
